// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 32) return "static/js/824fe75d56daa0cb0165.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"98cb2f5d753ea9b2745a","131":"1fede500e6e54839caa5","132":"d9fe41da8b4b6f0dd17f"}[chunkId] + ".chunk.js";
};